import { Signal } from "../core/Signal";

export class FullscreenUtil {
    public static onChange = Signal.create<[boolean]>();

    public static get isFullscreen(): boolean {
        return !!this.element;
    }

    public static get element(): HTMLElement | null {
        return (
            document.fullscreenElement ||
            (document as any).webkitFullscreenElement ||
            (document as any).mozFullScreenElement ||
            (document as any).msFullscreenElement ||
            null
        );
    }

    public static enter(element: HTMLElement): void {
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if ((element as any).webkitRequestFullscreen) {
            (element as any).webkitRequestFullscreen();
        } else if ((element as any).mozRequestFullScreen) {
            (element as any).mozRequestFullScreen();
        } else if ((element as any).msRequestFullscreen) {
            (element as any).msRequestFullscreen();
        }
    }

    public static exit(): void {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if ((document as any).webkitExitFullscreen) {
            (document as any).webkitExitFullscreen();
        } else if ((document as any).mozCancelFullScreen) {
            (document as any).mozCancelFullScreen();
        } else if ((document as any).msExitFullscreen) {
            (document as any).msExitFullscreen();
        }
    }

    public static get isSupported(): boolean {
        return !!(
            document.fullscreenEnabled ||
            (document as any).webkitFullscreenEnabled ||
            (document as any).mozFullScreenEnabled ||
            (document as any).msFullscreenEnabled
        );
    }
}

document.addEventListener("fullscreenchange", () => {
    FullscreenUtil.onChange.dispatch(FullscreenUtil.isFullscreen);
});
document.addEventListener("webkitfullscreenchange", () => {
    FullscreenUtil.onChange.dispatch(FullscreenUtil.isFullscreen);
});
document.addEventListener("mozfullscreenchange", () => {
    FullscreenUtil.onChange.dispatch(FullscreenUtil.isFullscreen);
});
document.addEventListener("MSFullscreenChange", () => {
    FullscreenUtil.onChange.dispatch(FullscreenUtil.isFullscreen);
});